import styled, { css } from 'styled-components';
import { media } from 'src/config/breakpoints';

export const AuthPanelLeft = styled.div`
  display: grid;
  grid-template-areas:
    'title'
    'course'
    'text';
  grid-template-rows:
    min-content
    min-content
    min-content;

  ${media.w.min.px992(css`
    grid-template-areas:
      'title'
      'text'
      'course';
    padding-left: 2.8vw;
    padding-top: 7vw;
    width: 50%;
  `)};

  ${media.w.min.px1440(css`
    padding-left: 2.5rem;
    padding-top: 6.25rem;
  `)};
`;
